module.exports = __webpack_public_path__ + "img/add_circle.1d9202e6.svg";